<template>
<v-dialog
    v-model="getModalReciboParcialContaReceber"
      
    max-width="500px"
    transition="dialog-transition"
>
<v-card>
    <v-card-title>Gerar Recibo</v-card-title>
    <v-card-text>
        <v-flex xs12 md12>
            <v-form>
               <v-select
                   :items="['CUPOM', 'A4']"
                   v-model="modelo_impressao"
                   label="Modelo impressão"
                   outlined
                   dense
               ></v-select> 
            </v-form>
        </v-flex>
    </v-card-text>
    <v-card-actions>
        <v-btn color="default" outlined @click="setModalReciboParcialContaReceber(false)" :loading="$store.getters.getOverlay">Voltar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="gerarRecibo()" outlined dense :loading="$store.getters.getOverlay">Gerar Recibo</v-btn>
    </v-card-actions>
</v-card>
    
</v-dialog>

</template>

<script>
import {mapActions, mapGetters} from "vuex"
    export default {

        data(){

            return {
                modelo_impressao: "A4" 
            }
        },
        computed: {
            ...mapGetters(['getModalReciboParcialContaReceber', 'getContaReceber', 'getMovimentacaoExtratoContaReceber'])
        },
        methods: {
            ...mapActions([
                'gerarReciboParcialContaReceber',
                'setModalReciboParcialContaReceber',
            ]),
            gerarRecibo(){
                this.gerarReciboParcialContaReceber({
                    id: this.getMovimentacaoExtratoContaReceber.id,
                    modelo_impressao: this.modelo_impressao
                })
            }
        }


    }
</script>